(function() {
  // === IDs reales que nos diste ===
  const CONTAINER_ID = '4ded16cd-381f-414b-845a-c07e876d1138';
  const VAT_ID = 'element-1-051f1095-74c5-42ce-b735-9f2c3e87c9f3';
  const COUNTRY_ID = 'element-1-de5fdd68-8a10-457a-8221-151e1b66d269';

  // ---- helpers ----
  function waitForEl(getter, timeout=15000) {
    return new Promise((resolve, reject) => {
      const check = () => {
        try { const el = getter(); if (el) { resolve(el); return true; } } catch(e) {}
        return false;
      };
      if (check()) return;
      const mo = new MutationObserver(() => { if (check()) mo.disconnect(); });
      mo.observe(document, { childList: true, subtree: true });
      setTimeout(() => { mo.disconnect(); reject(new Error('Timeout')); }, timeout);
    });
  }

  const normalizeVAT = v => (v||'').replace(/\s+/g,'').toUpperCase();
  const normalizeCC  = cc => cc ? (cc.toUpperCase() === 'GR' ? 'EL' : cc.toUpperCase()) : null;

  // UE…
  const EU_VAT = new Set(['AT','BE','BG','CY','CZ','DE','DK','EE','EL','ES','FI','FR','HR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','GB','GR']);
  // Países en los que SÍ validamos (UE + US)
  const AUTO_PREFIX_SET = new Set([...EU_VAT, 'US']);

  const patterns = {
    AT:/^[0-9A-Z]{8}$/, BE:/^[0-1][0-9]{9}$/, BG:/^[0-9]{9,10}$/, CY:/^[0-9]{8}[A-Z]$/,
    CZ:/^[0-9]{8,10}$/, DE:/^[0-9]{9}$/, DK:/^[0-9]{8}$/, EE:/^[0-9]{9}$/, EL:/^[0-9]{9}$/,
    ES:/^[A-Z0-9][0-9]{7}[A-Z0-9]$/, FI:/^[0-9]{8}$/, FR:/^[0-9A-Z]{2}[0-9]{9}$/,
    GB:/^[0-9]{9}([0-9]{3})?$/, HR:/^[0-9]{11}$/, HU:/^[0-9]{8}$/, IE:/^[0-9A-Z]{8,9}$/,
    IT:/^[0-9]{11}$/, LT:/^([0-9]{9}|[0-9]{12})$/, LU:/^[0-9]{8}$/, LV:/^[0-9]{11}$/,
    MT:/^[0-9]{8}$/, NL:/^[0-9]{9}B[0-9]{2}$/, PL:/^[0-9]{10}$/, PT:/^[0-9]{9}$/,
    RO:/^[0-9]{2,10}$/, SE:/^[0-9]{12}$/, SI:/^[0-9]{8}$/, SK:/^[0-9]{10}$/
  };

  function validateFormat(full, selectedCC) {
    const v = normalizeVAT(full);
    const m = /^([A-Z]{2})([A-Z0-9-]+)$/.exec(v);
    if (!m) return { ok:false, reason:'Add a 2-letter country prefix (e.g., ES, FR, DE, US).' };

    let cc = normalizeCC(m[1]);
    const rest = m[2];

    // Comparar prefijo con país SOLO si es UE/US
    const sel = normalizeCC(selectedCC);
    if (sel && AUTO_PREFIX_SET.has(sel) && cc !== sel) {
      return { ok:false, reason: `Prefix ${cc} does not match selected country (${sel}).` };
    }

    // US
    if (cc === 'US') {
      const SSN = /^\d{3}-?\d{2}-?\d{4}$/;
      if (SSN.test(rest)) {
        return { ok:false, reason:'US SSN is not accepted. Enter EIN (e.g., US12-3456789) or a valid state tax ID.' };
      }
      const EIN = /^\d{2}-?\d{7}$/;
      if (EIN.test(rest)) return { ok:true };
      const STATE_TAX = /^[A-Z0-9-]{5,15}$/;
      if (STATE_TAX.test(rest)) return { ok:true };
      return { ok:false, reason:'Invalid US tax ID. Enter EIN (e.g., US12-3456789) or a valid state tax ID.' };
    }

    // Resto UE
    const pat = patterns[cc];
    if (pat) return pat.test(rest) ? { ok:true } : { ok:false, reason: `Invalid VAT format for ${cc}.` };

    // Fallback
    return /^[A-Z0-9]{8,12}$/.test(rest)
      ? { ok:true }
      : { ok:false, reason:'Unrecognized VAT/tax format (length/characters).' };
  }

  // 1) Localizamos el contenedor por ID
  waitForEl(() => document.getElementById(CONTAINER_ID)).then((container) => {

    function bindToForm(form) {
      const vatInput = document.getElementById(VAT_ID) || form.querySelector('[id="'+VAT_ID+'"]');
      const countrySelect = document.getElementById(COUNTRY_ID) || form.querySelector('[id="'+COUNTRY_ID+'"]');
      const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (!vatInput) return;

      // feedback visual
      let statusEl = form.querySelector('#vat-status');
      if (!statusEl) {
        statusEl = document.createElement('div');
        statusEl.id = 'vat-status';
        statusEl.style.marginTop = '6px';
        statusEl.style.fontSize = '13px';
        statusEl.style.display = 'none';
        vatInput.insertAdjacentElement('afterend', statusEl);
      }
      const setStatus = (ok, msg) => {
        statusEl.style.display = 'block';
        statusEl.textContent = msg || (ok ? 'Valid VAT/tax format' : 'Invalid VAT/tax format');
        statusEl.style.color = ok ? '#0a7d27' : '#b00020';
        vatInput.style.border = ok ? '1px solid #0a7d27' : '1px solid #b00020';
        vatInput.setCustomValidity(ok ? '' : (msg || 'Invalid VAT/tax ID'));
      };
      const clearStatus = () => {
        statusEl.style.display = 'none';
        vatInput.style.border = '';
        vatInput.setCustomValidity('');
      };

      // === NUEVO: helper para saber si hay que validar según país ===
      function inScope() {
        const sel = normalizeCC(countrySelect && countrySelect.value);
        return !!(sel && AUTO_PREFIX_SET.has(sel));
      }

      function validateBeforeSubmit(showAlert=true) {
        // Si NO es UE/US → no validar ni exigir
        if (!inScope()) {
          clearStatus();
          vatInput.setCustomValidity('');
          return true;
        }

        let raw = (vatInput.value || '').trim();
        if (!raw) {
          setStatus(false, 'VAT/tax ID is required');
          if (showAlert) alert('Invalid VAT/tax ID: VAT/tax ID is required');
          return false;
        }

        // auto-prefijo solo si aplica
        const ccSel = normalizeCC(countrySelect && countrySelect.value);
        if (!/^[A-Z]{2}/.test(raw) && ccSel && AUTO_PREFIX_SET.has(ccSel)) {
          raw = ccSel + raw;
        }

        const res = validateFormat(raw, ccSel);
        if (!res.ok) {
          setStatus(false, res.reason || 'Invalid VAT/tax ID');
          if (showAlert) alert('Invalid VAT/tax ID: ' + (res.reason || 'Invalid VAT/tax ID'));
          return false;
        }

        vatInput.value = normalizeVAT(raw);
        clearStatus();
        return true;
      }

      // feedback en vivo (solo si aplica)
      const live = (() => { let t; return () => {
        clearTimeout(t);
        t=setTimeout(() => {
          if (!inScope()) { clearStatus(); return; }
          const raw = (vatInput.value || '').trim();
          if (!raw) { clearStatus(); return; }
          const sel = normalizeCC(countrySelect && countrySelect.value);
          const candidate = /^[A-Z]{2}/.test(raw) ? raw : (sel ? sel + raw : raw);
          const r = validateFormat(candidate, sel);
          if (r.ok) setStatus(true, 'Valid VAT/tax format'); else setStatus(false, r.reason);
        }, 250);
      }; })();

      vatInput.addEventListener('input', live);
      countrySelect && countrySelect.addEventListener('change', live);

      // submit estándar (captura)
      form.addEventListener('submit', function(e) {
        if (!validateBeforeSubmit(true)) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
      }, true);

      // click en botón submit (captura)
      if (submitBtn) {
        ['click','pointerdown'].forEach(evt => {
          submitBtn.addEventListener(evt, function(e) {
            if (!validateBeforeSubmit(true)) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
          }, true);
        });
      }

      // Enter en el form (captura)
      form.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' && !e.isComposing) {
          if (!validateBeforeSubmit(true)) { e.preventDefault(); e.stopImmediatePropagation(); return false; }
        }
      }, true);

      // submit programático
      try {
        if (form.submit && !form._vatSubmitWrapped) {
          const nativeSubmit = form.submit.bind(form);
          form.submit = function() {
            if (!validateBeforeSubmit(true)) return false;
            return nativeSubmit();
          };
          form._vatSubmitWrapped = true;
        }
        if (form.requestSubmit && !form._vatReqSubmitWrapped) {
          const nativeReq = form.requestSubmit.bind(form);
          form.requestSubmit = function(submitter) {
            if (!validateBeforeSubmit(true)) return false;
            return nativeReq(submitter);
          };
          form._vatReqSubmitWrapped = true;
        }
      } catch(_) {}

      // Deshabilitar botón SOLO cuando el país requiere tax ID
      function toggleSubmitDisabled() {
        if (!submitBtn) return;
        const sel = normalizeCC(countrySelect && countrySelect.value);
        if (!sel || !AUTO_PREFIX_SET.has(sel)) {
          submitBtn.disabled = false;
          submitBtn.style.cursor = '';
          submitBtn.style.opacity = '';
          return;
        }
        const raw0 = (vatInput.value || '').trim();
        const rawWithCC = /^[A-Z]{2}/.test(raw0) ? raw0 : (sel ? sel + raw0 : raw0);
        const ok = !!raw0 && validateFormat(rawWithCC, sel).ok;
        submitBtn.disabled = !ok;
        submitBtn.style.cursor = ok ? '' : 'not-allowed';
        submitBtn.style.opacity = ok ? '' : '0.7';
      }
      vatInput.addEventListener('input', toggleSubmitDisabled);
      countrySelect && countrySelect.addEventListener('change', toggleSubmitDisabled);
      setTimeout(toggleSubmitDisabled, 0);
    }

    // bind
    const existingForm = container.querySelector('form');
    if (existingForm) bindToForm(existingForm);
    else {
      const mo = new MutationObserver(() => {
        const f = container.querySelector('form');
        if (f) { mo.disconnect(); bindToForm(f); }
      });
      mo.observe(container, { childList:true, subtree:true });
      setTimeout(() => mo.disconnect(), 15000);
    }

  }).catch(() => {
    // Fallback documento: NO validar si no es UE/US
    document.addEventListener('submit', function(e) {
      const vatInput = e.target && e.target.querySelector('[id="'+VAT_ID+'"]');
      if (!vatInput) return;
      const countrySelect = e.target.querySelector('[id="'+COUNTRY_ID+'"]');
      const sel = normalizeCC(countrySelect && countrySelect.value);
      if (!sel || !AUTO_PREFIX_SET.has(sel)) return; // <-- aquí salimos si no es UE/US

      let raw = (vatInput.value || '').trim();
      if (!raw) { alert('Invalid VAT/tax ID: VAT/tax ID is required'); e.preventDefault(); e.stopImmediatePropagation(); return false; }
      if (!/^[A-Z]{2}/.test(raw) && sel) raw = sel + raw;
      const res = validateFormat(raw, sel);
      if (!res.ok) { alert('Invalid VAT/tax ID: ' + (res.reason || 'Invalid VAT/tax ID')); e.preventDefault(); e.stopImmediatePropagation(); return false; }
    }, true);
  });
})();
